import { Capacitor } from '@capacitor/core';

/**
 * Detects if the app is running in a native Capacitor environment
 * @returns true if running on iOS or Android, false if on web
 */
export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}

/**
 * Gets the current platform name
 * @returns 'ios', 'android', or 'web'
 */
export function getPlatform(): 'ios' | 'android' | 'web' {
  const platform = Capacitor.getPlatform();
  if (platform === 'ios' || platform === 'android') {
    return platform;
  }
  return 'web';
}

/**
 * Determines if Apple In-App Purchase should be used
 * @returns true for iOS native, false for web/Android
 */
export function shouldUseIAP(): boolean {
  return getPlatform() === 'ios';
}

/**
 * Determines if Stripe should be used
 * @returns true for web, false for native iOS
 */
export function shouldUseStripe(): boolean {
  return getPlatform() === 'web';
}

/**
 * Checks if running on iOS
 * @returns true if platform is iOS
 */
export function isRunningOnIOS(): boolean {
  return getPlatform() === 'ios';
}

/**
 * Checks if running on Android
 * @returns true if platform is Android
 */
export function isRunningOnAndroid(): boolean {
  return getPlatform() === 'android';
}





